import * as React from "react";
import {withTranslation} from "react-i18next";
import {ValueVsExpectedAlertTooltip} from "./ValueVsExpectedAlertTooltip";
import {COLUMN_CELL_INVALID_CONTENT} from "../../../columns";
import {DashboardCell} from "./DashboardCell";

class DashboardValueVsExpectedCellClass extends DashboardCell {
    alertCssClasses() {
        if (this.props.alertSnoozed) {
            return `-${this.props.alertLevel} -snoozed`;
        } else {
            return `-${this.props.alertLevel}`;
        }
    }

    render() {
        const { className } = this.props;
        const baseClasses = `double-data ${this.processingCssClasses()}`;
        const finalClassName = className ? `${baseClasses} ${className}` : baseClasses;
        return (
            <td className={finalClassName} style={this.props.style}>
                {this.renderCellContent()}
            </td>
        );
    }

    renderCellContent() {
        // Sin valor, el ⓘ del `live_meta` es lo único que explica el hueco (p. ej. Google no informa
        // la cuota de esa campaña). Sin él la columna con comparación quedaba vacía y muda, mientras
        // la de sin comparación ya lo mostraba (`DashboardSingleValueCell`).
        if(this.props.value === COLUMN_CELL_INVALID_CONTENT)
            return [
                <React.Fragment key="warning">{this.renderWarningIfNecessary()}</React.Fragment>,
                <React.Fragment key="live-meta">{this.renderLiveMetaIfNecessary()}</React.Fragment>,
            ];

        return [
                <React.Fragment key="warning">{this.renderWarningIfNecessary()}</React.Fragment>,
                <React.Fragment key="live-meta">{this.renderLiveMetaIfNecessary()}</React.Fragment>,
                <React.Fragment key="value">{this.props.value}</React.Fragment>,
                <div key="fluctuation"
                     title={this.props.title}
                     className={`item -${this.props.fluctuation} ${this.alertCssClasses()}`}>
                    {this.props.fluctuationPercentage}
                    {this.renderTooltip()}
                </div>
            ];
    }

    hasDataForTooltip() {
        return this.props.mainPeriod !== undefined
            && this.props.vsPeriod !== undefined
            && this.props.value !== undefined
            && this.props.metricName !== undefined
            && this.props.expectedValue !== undefined;
    }

    hasDataExplorerTooltip() {
        return this.props.dataExplorerTooltipComponent !== undefined
            && this.props.mainPeriodValue !== undefined
            && this.props.comparisonPeriodValue !== undefined
            && this.props.mainPeriodLabel !== undefined
            && this.props.comparisonPeriodLabel !== undefined
            && this.props.comparisonPeriodLabel !== '' // Only show if comparison period exists
            && this.props.metricName !== undefined;
    }

    renderTooltip() {
        // Check for Data Explorer tooltip first
        if (this.hasDataExplorerTooltip()) {
            const DataExplorerComparisonTooltip = this.props.dataExplorerTooltipComponent;
            if (DataExplorerComparisonTooltip) {
                return <DataExplorerComparisonTooltip
                    mainPeriodValue={this.props.mainPeriodValue}
                    comparisonPeriodValue={this.props.comparisonPeriodValue}
                    mainPeriodLabel={this.props.mainPeriodLabel}
                    comparisonPeriodLabel={this.props.comparisonPeriodLabel}
                    metricName={this.props.metricName}
                />;
            }
        }

        // Fallback to original Dashboard tooltip
        if(!this.hasDataForTooltip()) {
            return
        }

        return <ValueVsExpectedAlertTooltip
            mainPeriod={this.props.mainPeriod}
            vsPeriod={this.props.vsPeriod}
            mainPeriodValue={this.props.value}
            vsPeriodProportionalValue={this.props.expectedValue}
            metricName={this.props.metricName}
            vsPeriodValue={this.props.vsPeriodValue}
        />;
    }
}

export const DashboardValueVsExpectedCell = withTranslation()(DashboardValueVsExpectedCellClass);
